<template
  ><div>
    <alert :show="showDebug">
      <template v-slot:title>
        Debug Menu
      </template>
      <template v-slot:content>
        <div v-if="!isLoading" class="debug-options">
          <debug-menu-button
            :theme="'contrast-light'"
            class="flex-1 debug-button"
            @click="generateDummyAnswers()"
          >
            Generate Answers
            <icon-tick v-if="answersGenerated" :count="1" />
          </debug-menu-button>
          <debug-menu-button
            :theme="'contrast-light'"
            class="flex-1 debug-button"
            @click="dummyMatchCandidates()"
          >
            Match Candidates
            <icon-tick v-if="candidatesMatched" :count="1" />
          </debug-menu-button>
          <debug-menu-button
            :theme="'contrast-light'"
            class="flex-1 debug-button"
            @click="unlockProgress()"
          >
            Unlock Progress
            <icon-tick v-if="progressUnlocked" :count="1" />
          </debug-menu-button>
          <debug-menu-button
            :theme="'contrast-light'"
            class="flex-1 debug-button"
            @click="unlockAll()"
          >
            Unlock All
            <icon-tick v-if="allUnlocked" :count="1" />
          </debug-menu-button>
          <!-- <navigate-small-button :theme="'contrast-light'" class="flex-1 " @click="resetDebug()">
            Reset
          </navigate-small-button> -->
        </div>
        <div v-else>is loading... please wait</div>
      </template>
      <template v-slot:footer>
        <debug-menu-button
          :theme="'contrast-light'"
          class="flex-1 uppercase"
          @click="showHideDebug()"
        >
          Close
        </debug-menu-button>
      </template>
    </alert>
    <debug-menu-button
      :theme="'contrast-light'"
      class="uppercase debug-menu"
      style="line-height:.5rem;"
      @click="showHideDebug()"
      v-if="canShowDebug"
    >
      debug
    </debug-menu-button>
  </div>
</template>
<script>
import Alert from "@/components/layouts/Alert";
import DebugMenuButton from "@/components/buttons/DebugMenuButton";
import { ProgressStepId } from "@/utils/ProgressStepId";
import { ElectionProgressStepId } from "@/utils/ElectionProgressStepId";
import { ProgressState } from "@/utils/ProgressState";
import { mapActions, mapGetters, mapMutations } from "vuex";
import IconTick from "../icons/IconTick";

export default {
  name: "DebugMenu",
  components: {
    Alert,
    DebugMenuButton,
    IconTick
  },
  data: () => ({
    showDebug: false,
    isLoading: false,
    answersGenerated: false,
    candidatesMatched: false,
    progressUnlocked: false,
    allUnlocked: false
  }),
  computed: {
    ...mapGetters("election", ["elections"]),
    ...mapGetters("questionnaire", ["questions", "responses"]),
    ...mapGetters("candidate", ["candidates", "matches"]),
    ...mapGetters("user", ["progression"]),
    canShowDebug() {
      return process.env.VUE_APP_DEBUG_ENABLED === "true";
    }
  },
  mounted() {
    this.checkProgress();
  },
  methods: {
    ...mapActions("user", ["updateProgression"]),
    ...mapActions("election", ["updateElectionProgression"]),
    ...mapMutations("questionnaire", ["resetAnswers"]),
    checkProgress() {
      // check if answers have been generated
      if (this.questions.length === this.responses.length) {
        this.answersGenerated = true;
      }
      // check if candidates have been matched
      if (this.candidates.length === Object.keys(this.matches).length) {
        this.candidatesMatched = true;
      }
      // check if progress was unlocked
      if (
        Object.keys(ProgressStepId).length ===
        Object.keys(this.progression).length
      ) {
        this.progressUnlocked = true;
      }
      // check if all was unlocked
      if (
        this.answersGenerated &&
        this.candidatesMatched &&
        this.progressUnlocked
      ) {
        this.allUnlocked = true;
      }
    },
    showHideDebug() {
      this.showDebug = !this.showDebug;
    },
    async generateDummyAnswers() {
      this.isLoading = true;
      this.answersGenerated = true;
      await this.$store.dispatch(
        "questionnaire/setResponsesForAllQuestions",
        100
      );
      this.isLoading = false;
    },
    async dummyMatchCandidates() {
      this.isLoading = true;
      this.candidatesMatched = true;
      await this.$store.dispatch("candidate/matchAllCandidates");
      this.isLoading = false;
    },
    async unlockProgress() {
      this.isLoading = true;
      this.progressUnlocked = true;
      for (const key in ProgressStepId) {
        await this.updateProgression({
          key: ProgressStepId[key],
          data: { state: ProgressState.Completed }
        });
      }
      for (const key in this.elections) {
        await this.updateElectionProgression({
          electionId: this.elections[key],
          key: ElectionProgressStepId.Match,
          data: { state: ProgressState.Completed }
        });
      }
      this.isLoading = false;
    },
    async unlockAll() {
      this.isLoading = true;
      this.allUnlocked = true;
      await this.generateDummyAnswers();
      await this.dummyMatchCandidates();
      await this.unlockProgress();
      this.isLoading = false;
    },
    async resetDebug() {
      // TODO
    }
  }
};
</script>
<style lang="scss" scoped>
.debug-menu {
  position: absolute;
  top: 1.624rem;
  width: 6em;
  left: calc(50% - 3em);
}
.debug-options {
  display: flex;
  flex-direction: column;
}
.debug-button {
  width: 100%;
  margin-bottom: 0.5rem;
}

@media (max-width: 440px) {
  .debug-menu {
    font-size: 0.8rem;
  }
}

@media (min-width: 1024px) {
  .debug-menu {
    top: 0;
  }
}
</style>
